module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-container Student_tutorsIndex"
  }, [_vm._v("\n  現在表示数 " + _vm._s(_vm.max) + "\n\n  "), _c('student-tutors-modal', {
    attrs: {
      "modal": _vm.modal
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  }), _vm._v("ソート"), _c('i', {
    staticClass: "fa fa-fw fa-angle-down"
  }), _vm._v(" "), _vm._l((_vm.columns), function(list, index) {
    return _c('span', {
      key: index
    }, [(_vm.sortColumn === _vm.columns[index].code) ? [_vm._v("\n      " + _vm._s(list.name) + " : " + _vm._s(_vm.sortState) + "\n    ")] : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('h1', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    staticClass: "m-label m-label-custom",
    class: {
      'slideActive': _vm.columnsFlg
    },
    on: {
      "click": function($event) {
        return _vm.switchColumns('columnsFlg')
      }
    }
  }, [_vm._v("項目")]), _vm._v(" "), _c('h1', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    staticClass: "m-label m-label-custom",
    class: {
      'slideActive': _vm.columnBtn === 1
    },
    on: {
      "click": function($event) {
        return _vm.switchColumnBtn(1)
      }
    }
  }, [_vm._v("探し中")]), _vm._v(" "), _c('h1', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    staticClass: "m-label m-label-custom",
    class: {
      'slideActive': _vm.columnBtn === 2
    },
    on: {
      "click": function($event) {
        return _vm.switchColumnBtn(2)
      }
    }
  }, [_vm._v("研修待ち")]), _vm._v(" "), _c('h1', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    staticClass: "m-label m-label-custom",
    class: {
      'slideActive': _vm.columnBtn === 3
    },
    on: {
      "click": function($event) {
        return _vm.switchColumnBtn(3)
      }
    }
  }, [_vm._v("紹介未")]), _vm._v(" "), _c('h1', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    staticClass: "m-label m-label-custom",
    class: {
      'slideActive': _vm.columnBtn === 4
    },
    on: {
      "click": function($event) {
        return _vm.switchColumnBtn(4)
      }
    }
  }, [_vm._v("初回日待ち")]), _vm._v(" "), _c('h1', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    staticClass: "m-label m-label-custom",
    class: {
      'slideActive': _vm.columnBtn === 5
    },
    on: {
      "click": function($event) {
        return _vm.switchColumnBtn(5)
      }
    }
  }, [_vm._v("未来探し")])]), _vm._v(" "), (_vm.columnsFlg) ? [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("RESET")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.all()
      }
    }
  }, [_vm._v("ALL")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.def()
      }
    }
  }, [_vm._v("DEFAULT")]), _vm._v(" "), _vm._l((_vm.columns), function(list, index) {
    return _c('btn', {
      key: index,
      staticClass: "m-btn--column",
      class: {
        'active': _vm.columns[index].show
      },
      nativeOn: {
        "click": function($event) {
          return _vm.switchV(index)
        }
      }
    }, [_vm._v(_vm._s(list.name))])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.columnBtn === 1) ? [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.save1()
      }
    }
  }, [_vm._v("SAVE")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.resetBtn1()
      }
    }
  }, [_vm._v("RESET")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.allBtn1()
      }
    }
  }, [_vm._v("ALL")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.defBtn1()
      }
    }
  }, [_vm._v("DEFAULT")]), _vm._v(" "), _vm._l((_vm.columns), function(list, index) {
    return _c('btn', {
      key: index,
      staticClass: "m-btn--column",
      class: {
        'active': _vm.columns[index].btn1Show
      },
      nativeOn: {
        "click": function($event) {
          return _vm.switchVbtn1(index)
        }
      }
    }, [_vm._v(_vm._s(list.name))])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.columnBtn === 2) ? [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.save2()
      }
    }
  }, [_vm._v("SAVE")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.resetBtn2()
      }
    }
  }, [_vm._v("RESET")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.allBtn2()
      }
    }
  }, [_vm._v("ALL")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.defBtn2()
      }
    }
  }, [_vm._v("DEFAULT")]), _vm._v(" "), _vm._l((_vm.columns), function(list, index) {
    return _c('btn', {
      key: index,
      staticClass: "m-btn--column",
      class: {
        'active': _vm.columns[index].btn2Show
      },
      nativeOn: {
        "click": function($event) {
          return _vm.switchVbtn2(index)
        }
      }
    }, [_vm._v(_vm._s(list.name))])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.columnBtn === 3) ? [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.save3()
      }
    }
  }, [_vm._v("SAVE")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.resetBtn3()
      }
    }
  }, [_vm._v("RESET")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.allBtn3()
      }
    }
  }, [_vm._v("ALL")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.defBtn3()
      }
    }
  }, [_vm._v("DEFAULT")]), _vm._v(" "), _vm._l((_vm.columns), function(list, index) {
    return _c('btn', {
      key: index,
      staticClass: "m-btn--column",
      class: {
        'active': _vm.columns[index].btn3Show
      },
      nativeOn: {
        "click": function($event) {
          return _vm.switchVbtn3(index)
        }
      }
    }, [_vm._v(_vm._s(list.name))])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.columnBtn === 4) ? [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.save4()
      }
    }
  }, [_vm._v("SAVE")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.resetBtn4()
      }
    }
  }, [_vm._v("RESET")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.allBtn4()
      }
    }
  }, [_vm._v("ALL")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.defBtn4()
      }
    }
  }, [_vm._v("DEFAULT")]), _vm._v(" "), _vm._l((_vm.columns), function(list, index) {
    return _c('btn', {
      key: index,
      staticClass: "m-btn--column",
      class: {
        'active': _vm.columns[index].btn4Show
      },
      nativeOn: {
        "click": function($event) {
          return _vm.switchVbtn4(index)
        }
      }
    }, [_vm._v(_vm._s(list.name))])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.columnBtn === 5) ? [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.save5()
      }
    }
  }, [_vm._v("SAVE")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.resetBtn5()
      }
    }
  }, [_vm._v("RESET")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.allBtn5()
      }
    }
  }, [_vm._v("ALL")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.defBtn5()
      }
    }
  }, [_vm._v("DEFAULT")]), _vm._v(" "), _vm._l((_vm.columns), function(list, index) {
    return _c('btn', {
      key: index,
      staticClass: "m-btn--column",
      class: {
        'active': _vm.columns[index].btn5Show
      },
      nativeOn: {
        "click": function($event) {
          return _vm.switchVbtn5(index)
        }
      }
    }, [_vm._v(_vm._s(list.name))])
  })], 2)] : _vm._e(), _vm._v(" "), _c('btn', {
    staticClass: "resetSearch",
    nativeOn: {
      "click": function($event) {
        return _vm.resetSearch($event)
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "10px"
    }
  }, [_c('student-tutors-add', {
    attrs: {
      "modal": _vm.modal
    },
    on: {
      "set": _vm.setSelect
    }
  }), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.btn1($event)
      }
    }
  }, [_vm._v("探し中")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.btn2($event)
      }
    }
  }, [_vm._v("研修待ち")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.btn3($event)
      }
    }
  }, [_vm._v("紹介未")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.btn4($event)
      }
    }
  }, [_vm._v("初回日待ち")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.btn5($event)
      }
    }
  }, [_vm._v("未来探し")])], 1), _vm._v(" "), _c('div', {
    staticClass: "index-box",
    on: {
      "scroll": _vm.offset
    }
  }, [_c('table-c', [_c('tr-c', {
    attrs: {
      "slot": "tr-th"
    },
    slot: "tr-th"
  }, [(_vm.columns[0].show) ? [_c('td-c', {
    staticClass: "sticky-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.id),
      expression: "search.id"
    }],
    attrs: {
      "type": "text",
      "placeholder": "検索"
    },
    domProps: {
      "value": (_vm.search.id)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "id", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[1].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.offices,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.office_id),
      callback: function($$v) {
        _vm.$set(_vm.watch, "office_id", $$v)
      },
      expression: "watch.office_id"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[2].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.filteredUsers,
      "label": "user",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.user_id),
      callback: function($$v) {
        _vm.$set(_vm.watch, "user_id", $$v)
      },
      expression: "watch.user_id"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[3].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "tag-placeholder": "Add this as new tag",
      "placeholder": "",
      "label": "name",
      "track-by": "value",
      "options": _vm.state,
      "multiple": true,
      "taggable": true,
      "show-labels": false
    },
    model: {
      value: (_vm.watch.state),
      callback: function($$v) {
        _vm.$set(_vm.watch, "state", $$v)
      },
      expression: "watch.state"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[4].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.matching_type,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.matching_type),
      callback: function($$v) {
        _vm.$set(_vm.watch, "matching_type", $$v)
      },
      expression: "watch.matching_type"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[5].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.change_reason,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.change_reason),
      callback: function($$v) {
        _vm.$set(_vm.watch, "change_reason", $$v)
      },
      expression: "watch.change_reason"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[6].show) ? [_c('td-c', {
    staticClass: "sticky-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.filing_date),
      expression: "search.filing_date"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.filing_date)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "filing_date", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[7].show) ? [_c('td-c', {
    staticClass: "sticky-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.elapsed),
      expression: "search.elapsed"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.elapsed)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "elapsed", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[8].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.matching_month,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.matching_month),
      callback: function($$v) {
        _vm.$set(_vm.watch, "matching_month", $$v)
      },
      expression: "watch.matching_month"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[9].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.tel,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.seven_days_tel),
      callback: function($$v) {
        _vm.$set(_vm.watch, "seven_days_tel", $$v)
      },
      expression: "watch.seven_days_tel"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[10].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.tel,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.ten_days_tel),
      callback: function($$v) {
        _vm.$set(_vm.watch, "ten_days_tel", $$v)
      },
      expression: "watch.ten_days_tel"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[11].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.tel,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.fourteen_days_tel),
      callback: function($$v) {
        _vm.$set(_vm.watch, "fourteen_days_tel", $$v)
      },
      expression: "watch.fourteen_days_tel"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[12].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.filteredUsers,
      "label": "user",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.charge_person),
      callback: function($$v) {
        _vm.$set(_vm.watch, "charge_person", $$v)
      },
      expression: "watch.charge_person"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[13].show) ? [_c('td-c', {
    staticClass: "sticky-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.matching_date),
      expression: "search.matching_date"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.matching_date)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "matching_date", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[14].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.filteredUsers,
      "label": "user",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.decision_person),
      callback: function($$v) {
        _vm.$set(_vm.watch, "decision_person", $$v)
      },
      expression: "watch.decision_person"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[15].show) ? [_c('td-c', {
    staticClass: "sticky-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.training_date),
      expression: "search.training_date"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.training_date)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "training_date", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[16].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.zumi,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.training_check),
      callback: function($$v) {
        _vm.$set(_vm.watch, "training_check", $$v)
      },
      expression: "watch.training_check"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[17].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.check,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.document),
      callback: function($$v) {
        _vm.$set(_vm.watch, "document", $$v)
      },
      expression: "watch.document"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[18].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.check,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.document_sending_check),
      callback: function($$v) {
        _vm.$set(_vm.watch, "document_sending_check", $$v)
      },
      expression: "watch.document_sending_check"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[19].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.check,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.document_receipt_check),
      callback: function($$v) {
        _vm.$set(_vm.watch, "document_receipt_check", $$v)
      },
      expression: "watch.document_receipt_check"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[20].show) ? [_c('td-c', {
    staticClass: "sticky-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.first_day_limit),
      expression: "search.first_day_limit"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.first_day_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "first_day_limit", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[21].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.check,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.first_day_check),
      callback: function($$v) {
        _vm.$set(_vm.watch, "first_day_check", $$v)
      },
      expression: "watch.first_day_check"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[22].show) ? [_c('td-c', {
    staticClass: "sticky-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.first_day),
      expression: "search.first_day"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.first_day)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "first_day", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[23].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.filteredUsers,
      "label": "user",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.hold_person),
      callback: function($$v) {
        _vm.$set(_vm.watch, "hold_person", $$v)
      },
      expression: "watch.hold_person"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[24].show) ? [_c('td-c', {
    staticClass: "sticky-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.family_tel_limit),
      expression: "search.family_tel_limit"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.family_tel_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "family_tel_limit", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[25].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.orderedPrefs,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.family_pref),
      callback: function($$v) {
        _vm.$set(_vm.watch, "family_pref", $$v)
      },
      expression: "watch.family_pref"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[26].show) ? [_c('td-c', {
    staticClass: "sticky-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.family_address),
      expression: "search.family_address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.family_address)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "family_address", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[27].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.student_state,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.student_state),
      callback: function($$v) {
        _vm.$set(_vm.watch, "student_state", $$v)
      },
      expression: "watch.student_state"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[28].show) ? [_c('td-c', {
    staticClass: "sticky-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.student_name),
      expression: "search.student_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.student_name)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "student_name", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[29].show) ? [_c('td-c', {
    staticClass: "sticky-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.student_kana),
      expression: "search.student_kana"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.student_kana)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "student_kana", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[30].show) ? [_c('td-c', {
    staticClass: "select sticky-1"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.grade,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.student_grade),
      callback: function($$v) {
        _vm.$set(_vm.watch, "student_grade", $$v)
      },
      expression: "watch.student_grade"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[31].show) ? [_c('td-c', {
    staticClass: "sticky-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.tutor_name),
      expression: "search.tutor_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.tutor_name)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "tutor_name", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[32].show) ? [_c('td-c', {
    staticClass: "sticky-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.tutor_kana),
      expression: "search.tutor_kana"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.tutor_kana)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "tutor_kana", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[33].show) ? [_c('td-c', {
    staticClass: "sticky-1",
    staticStyle: {
      "background": "#eee"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.columns[34].show) ? [_c('td-c', {
    staticClass: "sticky-1",
    staticStyle: {
      "background": "#eee"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.columns[35].show) ? [_c('td-c', {
    staticClass: "sticky-1",
    staticStyle: {
      "background": "#eee"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.columns[36].show) ? [_c('td-c', {
    staticClass: "sticky-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.note),
      expression: "search.note"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.note)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "note", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[37].show) ? [_c('td-c', {
    staticClass: "sticky-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.created_at),
      expression: "search.created_at"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.created_at)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "created_at", $event.target.value)
      }
    }
  })])] : _vm._e()], 2), _vm._v(" "), _c('tr-c', {
    attrs: {
      "slot": "tr-th"
    },
    slot: "tr-th"
  }, [(_vm.columns[0].show) ? [_c('td-c', {
    staticClass: "sticky-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_id),
      expression: "search.not_id"
    }],
    attrs: {
      "type": "text",
      "placeholder": "除外"
    },
    domProps: {
      "value": (_vm.search.not_id)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_id", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[1].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.offices,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_office_id),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_office_id", $$v)
      },
      expression: "watch.not_office_id"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[2].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.filteredUsers,
      "label": "user",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_user_id),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_user_id", $$v)
      },
      expression: "watch.not_user_id"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[3].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "tag-placeholder": "Add this as new tag",
      "placeholder": "",
      "label": "name",
      "track-by": "value",
      "options": _vm.state,
      "multiple": true,
      "taggable": true,
      "show-labels": false
    },
    model: {
      value: (_vm.watch.not_state),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_state", $$v)
      },
      expression: "watch.not_state"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[4].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.matching_type,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_matching_type),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_matching_type", $$v)
      },
      expression: "watch.not_matching_type"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[5].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.change_reason,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_change_reason),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_change_reason", $$v)
      },
      expression: "watch.not_change_reason"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[6].show) ? [_c('td-c', {
    staticClass: "sticky-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_filing_date),
      expression: "search.not_filing_date"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_filing_date)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_filing_date", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[7].show) ? [_c('td-c', {
    staticClass: "sticky-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_elapsed),
      expression: "search.not_elapsed"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_elapsed)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_elapsed", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[8].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.matching_month,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_matching_month),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_matching_month", $$v)
      },
      expression: "watch.not_matching_month"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[9].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.tel,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_seven_days_tel),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_seven_days_tel", $$v)
      },
      expression: "watch.not_seven_days_tel"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[10].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.tel,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_ten_days_tel),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_ten_days_tel", $$v)
      },
      expression: "watch.not_ten_days_tel"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[11].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.tel,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_fourteen_days_tel),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_fourteen_days_tel", $$v)
      },
      expression: "watch.not_fourteen_days_tel"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[12].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.filteredUsers,
      "label": "user",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_charge_person),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_charge_person", $$v)
      },
      expression: "watch.not_charge_person"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[13].show) ? [_c('td-c', {
    staticClass: "sticky-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_matching_date),
      expression: "search.not_matching_date"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_matching_date)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_matching_date", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[14].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.filteredUsers,
      "label": "user",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_decision_person),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_decision_person", $$v)
      },
      expression: "watch.not_decision_person"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[15].show) ? [_c('td-c', {
    staticClass: "sticky-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_training_date),
      expression: "search.not_training_date"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_training_date)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_training_date", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[16].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.zumi,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_training_check),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_training_check", $$v)
      },
      expression: "watch.not_training_check"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[17].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.check,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_document),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_document", $$v)
      },
      expression: "watch.not_document"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[18].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.check,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_document_sending_check),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_document_sending_check", $$v)
      },
      expression: "watch.not_document_sending_check"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[19].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.check,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_document_receipt_check),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_document_receipt_check", $$v)
      },
      expression: "watch.not_document_receipt_check"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[20].show) ? [_c('td-c', {
    staticClass: "sticky-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_first_day_limit),
      expression: "search.not_first_day_limit"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_first_day_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_first_day_limit", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[21].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.check,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_first_day_check),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_first_day_check", $$v)
      },
      expression: "watch.not_first_day_check"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[22].show) ? [_c('td-c', {
    staticClass: "sticky-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_first_day),
      expression: "search.not_first_day"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_first_day)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_first_day", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[23].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.filteredUsers,
      "label": "user",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_hold_person),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_hold_person", $$v)
      },
      expression: "watch.not_hold_person"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[24].show) ? [_c('td-c', {
    staticClass: "sticky-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_family_tel_limit),
      expression: "search.not_family_tel_limit"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_family_tel_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_family_tel_limit", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[25].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.orderedPrefs,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_family_pref),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_family_pref", $$v)
      },
      expression: "watch.not_family_pref"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[26].show) ? [_c('td-c', {
    staticClass: "sticky-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_family_address),
      expression: "search.not_family_address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_family_address)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_family_address", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[27].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.student_state,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_student_state),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_student_state", $$v)
      },
      expression: "watch.not_student_state"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[28].show) ? [_c('td-c', {
    staticClass: "sticky-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_student_name),
      expression: "search.not_student_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_student_name)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_student_name", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[29].show) ? [_c('td-c', {
    staticClass: "sticky-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_student_kana),
      expression: "search.not_student_kana"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_student_kana)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_student_kana", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[30].show) ? [_c('td-c', {
    staticClass: "select sticky-2"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.grade,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watch.not_student_grade),
      callback: function($$v) {
        _vm.$set(_vm.watch, "not_student_grade", $$v)
      },
      expression: "watch.not_student_grade"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.columns[31].show) ? [_c('td-c', {
    staticClass: "sticky-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_tutor_name),
      expression: "search.not_tutor_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_tutor_name)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_tutor_name", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[32].show) ? [_c('td-c', {
    staticClass: "sticky-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_tutor_kana),
      expression: "search.not_tutor_kana"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_tutor_kana)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_tutor_kana", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[33].show) ? [_c('td-c', {
    staticClass: "sticky-2",
    staticStyle: {
      "background": "#eee"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.columns[34].show) ? [_c('td-c', {
    staticClass: "sticky-2",
    staticStyle: {
      "background": "#eee"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.columns[35].show) ? [_c('td-c', {
    staticClass: "sticky-2",
    staticStyle: {
      "background": "#eee"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.columns[36].show) ? [_c('td-c', {
    staticClass: "sticky-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_note),
      expression: "search.not_note"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_note)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_note", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.columns[37].show) ? [_c('td-c', {
    staticClass: "sticky-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_created_at),
      expression: "search.not_created_at"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_created_at)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_created_at", $event.target.value)
      }
    }
  })])] : _vm._e()], 2), _vm._v(" "), _c('tr-c', {
    attrs: {
      "slot": "tr-th"
    },
    slot: "tr-th"
  }, [(_vm.columns[0].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "50px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("id")
      }
    }
  }, [_vm._v("ID")])] : _vm._e(), _vm._v(" "), (_vm.columns[1].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "80px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("office_id")
      }
    }
  }, [_vm._v("営業所")])] : _vm._e(), _vm._v(" "), (_vm.columns[2].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("user_id")
      }
    }
  }, [_vm._v("登録者")])] : _vm._e(), _vm._v(" "), (_vm.columns[3].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("state")
      }
    }
  }, [_vm._v("状態")])] : _vm._e(), _vm._v(" "), (_vm.columns[4].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("matching_type")
      }
    }
  }, [_vm._v("種類")])] : _vm._e(), _vm._v(" "), (_vm.columns[5].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("change_reason")
      }
    }
  }, [_vm._v("チェンジ理由")])] : _vm._e(), _vm._v(" "), (_vm.columns[6].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "80px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("filing_date")
      }
    }
  }, [_vm._v("提出日")])] : _vm._e(), _vm._v(" "), (_vm.columns[7].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "80px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("elapsed")
      }
    }
  }, [_vm._v("経過日数")])] : _vm._e(), _vm._v(" "), (_vm.columns[8].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "80px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("matching_month")
      }
    }
  }, [_vm._v("探し月")])] : _vm._e(), _vm._v(" "), (_vm.columns[9].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "50px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("seven_days_tel")
      }
    }
  }, [_vm._v("7日")])] : _vm._e(), _vm._v(" "), (_vm.columns[10].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "50px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("ten_days_tel")
      }
    }
  }, [_vm._v("10日")])] : _vm._e(), _vm._v(" "), (_vm.columns[11].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "50px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("fourteen_days_tel")
      }
    }
  }, [_vm._v("14日")])] : _vm._e(), _vm._v(" "), (_vm.columns[12].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("charge_person")
      }
    }
  }, [_vm._v("探し担当")])] : _vm._e(), _vm._v(" "), (_vm.columns[13].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "80px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("matching_date")
      }
    }
  }, [_vm._v("決めた日")])] : _vm._e(), _vm._v(" "), (_vm.columns[14].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("decision_person")
      }
    }
  }, [_vm._v("決めた人")])] : _vm._e(), _vm._v(" "), (_vm.columns[15].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "50px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("training_date")
      }
    }
  }, [_vm._v("研修日")])] : _vm._e(), _vm._v(" "), (_vm.columns[16].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "50px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("training_check")
      }
    }
  }, [_vm._v("研修check")])] : _vm._e(), _vm._v(" "), (_vm.columns[17].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "50px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("document")
      }
    }
  }, [_vm._v("資料")])] : _vm._e(), _vm._v(" "), (_vm.columns[18].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "50px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("document_sending_check")
      }
    }
  }, [_vm._v("資料送付確認")])] : _vm._e(), _vm._v(" "), (_vm.columns[19].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "50px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("document_receipt_check")
      }
    }
  }, [_vm._v("資料受取確認")])] : _vm._e(), _vm._v(" "), (_vm.columns[20].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "80px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("first_day_limit")
      }
    }
  }, [_vm._v("初回日期限")])] : _vm._e(), _vm._v(" "), (_vm.columns[21].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "50px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("first_day_check")
      }
    }
  }, [_vm._v("初回")])] : _vm._e(), _vm._v(" "), (_vm.columns[22].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "80px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("first_day")
      }
    }
  }, [_vm._v("初回日")])] : _vm._e(), _vm._v(" "), (_vm.columns[23].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("hold_person")
      }
    }
  }, [_vm._v("持ってる人")])] : _vm._e(), _vm._v(" "), (_vm.columns[24].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "80px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("family_tel_limit")
      }
    }
  }, [_vm._v("家庭TEL期限")])] : _vm._e(), _vm._v(" "), (_vm.columns[25].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("family_pref")
      }
    }
  }, [_vm._v("都道府県")])] : _vm._e(), _vm._v(" "), (_vm.columns[26].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "200px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("family_address")
      }
    }
  }, [_vm._v("住所")])] : _vm._e(), _vm._v(" "), (_vm.columns[27].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "200px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("student_state")
      }
    }
  }, [_vm._v("生徒状態")])] : _vm._e(), _vm._v(" "), (_vm.columns[28].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("student_name")
      }
    }
  }, [_vm._v("生徒")])] : _vm._e(), _vm._v(" "), (_vm.columns[29].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("student_kana")
      }
    }
  }, [_vm._v("せいと")])] : _vm._e(), _vm._v(" "), (_vm.columns[30].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("student_grade")
      }
    }
  }, [_vm._v("生徒学年")])] : _vm._e(), _vm._v(" "), (_vm.columns[31].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("tutor_name")
      }
    }
  }, [_vm._v("先生")])] : _vm._e(), _vm._v(" "), (_vm.columns[32].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("tutor_kana")
      }
    }
  }, [_vm._v("せんせい")])] : _vm._e(), _vm._v(" "), (_vm.columns[33].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("keep1")
      }
    }
  }, [_vm._v("候補1")])] : _vm._e(), _vm._v(" "), (_vm.columns[34].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("keep2")
      }
    }
  }, [_vm._v("候補2")])] : _vm._e(), _vm._v(" "), (_vm.columns[35].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "100px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("keep3")
      }
    }
  }, [_vm._v("候補3")])] : _vm._e(), _vm._v(" "), (_vm.columns[36].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "200px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("note")
      }
    }
  }, [_vm._v("備考")])] : _vm._e(), _vm._v(" "), (_vm.columns[37].show) ? [_c('th-c', {
    staticClass: "sticky-3",
    staticStyle: {
      "min-width": "80px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sort("created_at")
      }
    }
  }, [_vm._v("作成日")])] : _vm._e()], 2), _vm._v(" "), _vm._l((_vm.mapStudent_tutors), function(list, index) {
    return _c('tr-c', {
      key: index.id,
      staticClass: "tr_hover",
      attrs: {
        "slot": "tr-td"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.modalLink(list)
        }
      },
      slot: "tr-td"
    }, [(_vm.columns[0].show) ? [_c('td-c', [_vm._v(_vm._s(list.id))])] : _vm._e(), _vm._v(" "), (_vm.columns[1].show) ? [_c('td-c', [_vm._v(_vm._s(list.mapOffice_id))])] : _vm._e(), _vm._v(" "), (_vm.columns[2].show) ? [(list.user) ? _c('td-c', [_vm._v(_vm._s(list.user.user))]) : _c('td-c')] : _vm._e(), _vm._v(" "), (_vm.columns[3].show) ? [_c('td-c', [_vm._v(_vm._s(list.mapState))])] : _vm._e(), _vm._v(" "), (_vm.columns[4].show) ? [_c('td-c', [_vm._v(_vm._s(list.mapMatchingType))])] : _vm._e(), _vm._v(" "), (_vm.columns[5].show) ? [_c('td-c', [_vm._v(_vm._s(list.mapChangeReason))])] : _vm._e(), _vm._v(" "), (_vm.columns[6].show) ? [_c('td-c', [_vm._v(_vm._s(list.filing_date))])] : _vm._e(), _vm._v(" "), (_vm.columns[7].show) ? [_c('td-c', {
      class: {
        'orange': _vm.elapsed7(list.filing_date, list.state), 'red': _vm.elapsed10(list.filing_date, list.state)
      }
    }, [_vm._v(_vm._s(list.mapElapsed))])] : _vm._e(), _vm._v(" "), (_vm.columns[8].show) ? [_c('td-c', [_vm._v(_vm._s(list.matching_month))])] : _vm._e(), _vm._v(" "), (_vm.columns[9].show) ? [(list.seven_days_tel === 0) ? _c('td-c', {
      class: {
        'red': _vm.limit(list.filing_date, 7, list.state)
      }
    }) : _vm._e(), _vm._v(" "), (list.seven_days_tel === 1) ? _c('td-c', [_vm._v("○")]) : _vm._e(), _vm._v(" "), (list.seven_days_tel === 2) ? _c('td-c', {
      class: {
        'red': _vm.limit(list.filing_date, 7, list.state)
      }
    }, [_vm._v("留守")]) : _vm._e(), _vm._v(" "), (list.seven_days_tel === 3) ? _c('td-c', {
      class: {
        'red': _vm.limit(list.filing_date, 7, list.state)
      }
    }, [_vm._v("TEL")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.columns[10].show) ? [(list.ten_days_tel === 0) ? _c('td-c', {
      class: {
        'red': _vm.limit(list.filing_date, 10, list.state)
      }
    }) : _vm._e(), _vm._v(" "), (list.ten_days_tel === 1) ? _c('td-c', [_vm._v("○")]) : _vm._e(), _vm._v(" "), (list.ten_days_tel === 2) ? _c('td-c', {
      class: {
        'red': _vm.limit(list.filing_date, 10, list.state)
      }
    }, [_vm._v("留守")]) : _vm._e(), _vm._v(" "), (list.ten_days_tel === 3) ? _c('td-c', {
      class: {
        'red': _vm.limit(list.filing_date, 10, list.state)
      }
    }, [_vm._v("TEL")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.columns[11].show) ? [(list.fourteen_days_tel === 0) ? _c('td-c', {
      class: {
        'red': _vm.limit(list.filing_date, 14, list.state)
      }
    }) : _vm._e(), _vm._v(" "), (list.fourteen_days_tel === 1) ? _c('td-c', [_vm._v("○")]) : _vm._e(), _vm._v(" "), (list.fourteen_days_tel === 2) ? _c('td-c', {
      class: {
        'red': _vm.limit(list.filing_date, 14, list.state)
      }
    }, [_vm._v("留守")]) : _vm._e(), _vm._v(" "), (list.fourteen_days_tel === 3) ? _c('td-c', {
      class: {
        'red': _vm.limit(list.filing_date, 14, list.state)
      }
    }, [_vm._v("TEL")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.columns[12].show) ? [_c('td-c', [_vm._v(_vm._s(list.mapCharge_person))])] : _vm._e(), _vm._v(" "), (_vm.columns[13].show) ? [_c('td-c', [_vm._v(_vm._s(list.matching_date))])] : _vm._e(), _vm._v(" "), (_vm.columns[14].show) ? [_c('td-c', [_vm._v(_vm._s(list.mapDecision_person))])] : _vm._e(), _vm._v(" "), (_vm.columns[15].show) ? [_c('td-c', [_vm._v(_vm._s(list.training_date))])] : _vm._e(), _vm._v(" "), (_vm.columns[16].show) ? [(list.training_check === 0) ? _c('td-c') : _vm._e(), _vm._v(" "), (list.training_check === 1) ? _c('td-c', [_vm._v("済")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.columns[17].show) ? [(list.document === 0) ? _c('td-c') : _vm._e(), _vm._v(" "), (list.document === 1) ? _c('td-c', [_vm._v("○")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.columns[18].show) ? [(list.document_sending_check === 0) ? _c('td-c') : _vm._e(), _vm._v(" "), (list.document_sending_check === 1) ? _c('td-c', [_vm._v("○")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.columns[19].show) ? [(list.document_receipt_check === 0) ? _c('td-c') : _vm._e(), _vm._v(" "), (list.document_receipt_check === 1) ? _c('td-c', [_vm._v("○")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.columns[20].show) ? [_c('td-c', [_vm._v(_vm._s(list.first_day_limit))])] : _vm._e(), _vm._v(" "), (_vm.columns[21].show) ? [(list.first_day_check === 0) ? _c('td-c') : _vm._e(), _vm._v(" "), (list.first_day_check === 1) ? _c('td-c', [_vm._v("○")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.columns[22].show) ? [_c('td-c', [_vm._v(_vm._s(list.first_day))])] : _vm._e(), _vm._v(" "), (_vm.columns[23].show) ? [_c('td-c', [_vm._v(_vm._s(list.mapHold_person))])] : _vm._e(), _vm._v(" "), (_vm.columns[24].show) ? [_c('td-c', {
      class: {
        'red': _vm.limitFamily(list.family_tel_limit, list.state)
      }
    }, [_vm._v(_vm._s(list.family_tel_limit))])] : _vm._e(), _vm._v(" "), (_vm.columns[25].show) ? [_c('td-c', [_vm._v(_vm._s(list.mapFamilyPref))])] : _vm._e(), _vm._v(" "), (_vm.columns[26].show) ? [(list.student.family) ? [_c('td-c', [_vm._v("\n              " + _vm._s(list.student.family.address1) + " " + _vm._s(list.student.family.address2) + "\n            ")])] : [_c('td-c')]] : _vm._e(), _vm._v(" "), (_vm.columns[27].show) ? [(list.student) ? [_c('td-c', {
      staticClass: "link",
      nativeOn: {
        "click": function($event) {
          return _vm.linkStudent($event, list)
        }
      }
    }, [_vm._v(_vm._s(list.mapStudent_state))])] : [_c('td-c')]] : _vm._e(), _vm._v(" "), (_vm.columns[28].show) ? [(list.student) ? [_c('td-c', {
      staticClass: "link",
      nativeOn: {
        "click": function($event) {
          return _vm.linkStudent($event, list)
        }
      }
    }, [_vm._v(_vm._s(list.student.f_name) + " " + _vm._s(list.student.l_name))])] : [_c('td-c')]] : _vm._e(), _vm._v(" "), (_vm.columns[29].show) ? [(list.student) ? [_c('td-c', {
      staticClass: "link",
      nativeOn: {
        "click": function($event) {
          return _vm.linkStudent($event, list)
        }
      }
    }, [_vm._v(_vm._s(list.student.f_name_kana) + " " + _vm._s(list.student.l_name_kana))])] : [_c('td-c')]] : _vm._e(), _vm._v(" "), (_vm.columns[30].show) ? [(list.student) ? [_c('td-c', {
      staticClass: "link",
      nativeOn: {
        "click": function($event) {
          return _vm.linkStudent($event, list)
        }
      }
    }, [_vm._v(_vm._s(list.mapStudent_grade))])] : [_c('td-c')]] : _vm._e(), _vm._v(" "), (_vm.columns[31].show) ? [(list.tutor) ? [_c('td-c', {
      staticClass: "link",
      nativeOn: {
        "click": function($event) {
          return _vm.linkTutor($event, list)
        }
      }
    }, [_vm._v(_vm._s(list.tutor.f_name) + " " + _vm._s(list.tutor.l_name))])] : [_c('td-c')]] : _vm._e(), _vm._v(" "), (_vm.columns[32].show) ? [(list.tutor) ? [_c('td-c', {
      staticClass: "link",
      nativeOn: {
        "click": function($event) {
          return _vm.linkTutor($event, list)
        }
      }
    }, [_vm._v(_vm._s(list.tutor.f_name_kana) + " " + _vm._s(list.tutor.l_name_kana))])] : [_c('td-c')]] : _vm._e(), _vm._v(" "), (_vm.columns[33].show) ? [(list.keep_id1 > 0) ? [_c('td-c', {
      staticClass: "link",
      nativeOn: {
        "click": function($event) {
          return _vm.linkKeep1($event, list)
        }
      }
    }, [_vm._v(_vm._s(list.keep_f_name1) + " " + _vm._s(list.keep_l_name1))])] : [_c('td-c')]] : _vm._e(), _vm._v(" "), (_vm.columns[34].show) ? [(list.keep_id2 > 0) ? [_c('td-c', {
      staticClass: "link",
      nativeOn: {
        "click": function($event) {
          return _vm.linkKeep2($event, list)
        }
      }
    }, [_vm._v(_vm._s(list.keep_f_name2) + " " + _vm._s(list.keep_l_name2))])] : [_c('td-c')]] : _vm._e(), _vm._v(" "), (_vm.columns[35].show) ? [(list.keep_id3 > 0) ? [_c('td-c', {
      staticClass: "link",
      nativeOn: {
        "click": function($event) {
          return _vm.linkKeep3($event, list)
        }
      }
    }, [_vm._v(_vm._s(list.keep_f_name3) + " " + _vm._s(list.keep_l_name3))])] : [_c('td-c')]] : _vm._e(), _vm._v(" "), (_vm.columns[36].show) ? [_c('td-c', [_vm._v(_vm._s(list.note))])] : _vm._e(), _vm._v(" "), (_vm.columns[37].show) ? [_c('td-c', [_vm._v(_vm._s(list.created_at.substring(0, 10)))])] : _vm._e()], 2)
  })], 2)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb2826f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Student_tutors/Student_tutorsIndex.vue
// module id = 1489
// module chunks = 0